export default "__VITE_ASSET__DdK6rl3P__"